import { ContactPage } from '@gik/contact/components/ContactPage/ContactPage';
import { withTitle } from '@gik/core/hocs/withTitle';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';

export default function ContactPageComp() {
  return withTitle('Contact', <ContactPage />);
}

ContactPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};
